import { useEffect, useState } from 'react';
import { Flex, Icon, Stack } from '@chakra-ui/react';
import { FiPlus } from 'react-icons/fi';

import api from '../../services/api';
import { useAuth } from '../../hooks/auth';
import Sidebar from '../../components/Sidebar';
import Loading from '../../components/Loading';
import DTClientes from '../../components/ComponentsClientes/DTClientes';
import ModalAddEditCliente from '../../components/ComponentsClientes/ModalAddEditCliente';
import { ClienteDTO } from '../../dtos/ClienteDTO';

import { Container, Content, Header} from './styles';

const Clientes: React.FC = () => {
	const { permissions } = useAuth();

	const [loading, setLoading] = useState(true);

	const [clientes, setClientes] = useState<ClienteDTO[]>([]);
	const [cliente, setCliente] = useState<ClienteDTO>({} as ClienteDTO);

	const [idClienteModal, setIdClienteModal] = useState('');
	const [modalAddEditClienteVisible, setModalAddEditClienteVisible] = useState(false);

	async function fetchClientes() {
		setLoading(true);

		api.get(`/portal/cliente/${'*_*'}`)
			.then(response => {
				setClientes(response.data);
			})
			.finally(() => {
				setLoading(false);
			});
	};

	useEffect(() => {
		fetchClientes();
	}, []);

	// UseEffect para bloquear a rolagem ao abrir algum modal
	useEffect(() => {
		if (modalAddEditClienteVisible) {
			document.body.style.overflow = 'hidden';
		} else {
			document.body.style.overflow = 'auto';
		}
	}, [modalAddEditClienteVisible]);

	return (
		<>
			<Container>
				<Sidebar />

				{loading ? (
					<Loading />
				) : (
					<Content>
						<Header>
							<Flex flexDir="column">
								<h1>Adicionar Cliente</h1>
								<h2>Cadastre um novo cliente aqui.</h2>
							</Flex>

								{permissions.incluir && (
									<Flex flexDir="column" justify="flex-end" pt={[2, 0]}>
										<Stack direction={["column", "row"]} pb={[0, 2]}>
											<button onClick={() => {
												setIdClienteModal('');
												setModalAddEditClienteVisible(true);
											}}>
												<Icon as={FiPlus} fontSize={20} />&nbsp;
												NOVO
											</button>
											</Stack>
									</Flex>
								)}
						</Header>

							{clientes.length > 0 && (
								<DTClientes
									data={clientes}
									setIdClienteModal={setIdClienteModal}
									setModalAddEditClienteVisible={setModalAddEditClienteVisible}
								/>
							)}
					</Content>
				)}
			</Container>

			{modalAddEditClienteVisible && (
				<ModalAddEditCliente
					isVisible={modalAddEditClienteVisible}
					onClose={() => setModalAddEditClienteVisible(false)}
					id_cliente={idClienteModal}
					fetchClientes={fetchClientes}
					setClientesLoading={setLoading}
				/>
			)}
		</>
	)
};

export default Clientes;